import * as React from 'react';
import Project from 'src/entities/Project';
import Investment from 'src/entities/Investment';
import ImageContainer from 'src/modules/commons/images/Image.container';

interface Props {
  project: Project;
  investment: Investment;
}

const ProjectMainInfoCardSuccessFundedComponent: React.StatelessComponent<Props> = (props: Props) => {

  const myInvestment = new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'})
    .format(props.investment.amountInvested);

  let equity = (props.investment.quantityTickets * props.project.sharePercentage).toString();

  equity = parseFloat(equity).toLocaleString('es-ES', {maximumFractionDigits: 2});

  const premoneyValuation = new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'})
    .format(props.project.premoneyValuation);

  let state = null;
  switch (props.investment.status) {
    case 'Reviewing Profile':
      state = (
        <div className="row">
          <p className="padding-left-30">
            <div className="col-md-1">
              <div className="badge dot-circle-blue"/>
            </div>
            <div className="col-md-10 dot-circle-text-blue pad10">
              <span>
                Datos de inversión no confirmados</span>
            </div>
          </p>
        </div>
      );
      break;
    case 'Confirmed Profile':
      state = (
        <div className="row">
          <p className="padding-left-30">
            <div className="col-md-1">
              <span className="badge dot-circle-blue"/>
            </div>
            <div className="col-md-10 pad10">
              <strong className="dot-circle-text-blue"> Importe de inversión no confirmado </strong>
            </div>
          </p>
        </div>
      );
      break;

    case 'Reviewing Amount Change':
      state = (
        <div className="row">
          <p className="padding-left-30">
            <div className="col-md-1">
              <div className="badge dot-circle-orange"/>
            </div>
            <div className="col-md-10 dot-circle-text-orange pad10">
              <span>Validando tu petición</span>
            </div>
          </p>
        </div>
      );
      break; /*Importe de inversión no confirmado*/
    case 'Confirmed Amount':
      state = (
        <div className="row">
          <p className="padding-left-30">
            <div className="col-md-1">
              <div className="badge dot-circle-green"/>
            </div>
            <div className="col-md-10 dot-circle-text-green pad10">
              <span>Redactando contratos</span>
            </div>
          </p>
        </div>
      );
      break;
    case 'Reviewing Contracts':
      state = (
        <div className="row">
          <p className="padding-left-30">
            <div className="col-md-1">
              <div className="badge dot-circle-red"/>
            </div>
            <div className="col-md-10 dot-circle-text-red pad10">
              <span>Revisa los contratos de inversión</span>
            </div>
          </p>
        </div>
      );
      break;
    case 'Reviewing Contracts Correction':
      state = (
        <div className="row">
          <p className="padding-left-30">
            <div className="col-md-1">
              <div className="badge dot-circle-orange"/>
            </div>
            <div className="col-md-10 dot-circle-text-orange pad10">
              <span>Revisando la errata</span>
            </div>
          </p>
        </div>
      );
      break;
    case 'Accepted Contracts':
      state = (
        <div className="row">
          <p className="padding-left-30">
            <div className="col-md-1">
              <div className="badge dot-circle-red"/>
            </div>
            <div className="col-md-10 dot-circle-text-red pad10">
              <span>Firma de contratos de inversión</span>
            </div>
          </p>
        </div>
      );
      break;
    case 'Signed Contracts':
      state = (
        <div className="row">
          <p className="padding-left-30">
            <div className="col-md-1">
              <div className="badge dot-circle-green"/>
            </div>
            <div className="col-md-10 dot-circle-text-green pad10">
              <span>Desembolso de la inversión no realizado</span>
            </div>
          </p>
        </div>
      );
      break;
    default:
      state = (<span/>);
  }

  return (
    <section>
      <div className="projects-card-wallet projects-card-preview">
        <div
          className="simple-card"
          style={{
            height: '100%',
            width: '100%',
            position: 'relative',
            zIndex: 1,
            float: 'none',
            display: 'inline-table',
            padding: '30px 0'
          }}
        >
          <div className="col-md-4">
            <p className="padding-left-30 deco-title">
              <ImageContainer
                alt={props.project.company.name}
                url={props.project.company.logo}
              />
            </p>
            <div className="gap-20"/>
            <p className="padding-left-30">
              {props.project.company.description}
            </p>
            <div className="gap-10"/>
            {/*TODO when this is a thing add the label*/}
            {/*<p className="c-grey padding-left-30">
              <div className="rectangle-7">
                Incentivo Fiscal
              </div>
            </p>*/}
            <div className="gap-10"/>
            {
              props.project.status === 'Formalizando operación' ?
                state :
                null
            }
          </div>

          <div className="col-md-4 border-right-dashed border-left-dashed">
            {props.project.premoneyValuation === 0 ?
              null :
              <div className="icon-content">
                <img
                  alt="Euro"
                  className="icon"
                  src="/img/analytics-big.png"
                />
                <p className="inline-block f-s-20">
                  Valoración inicial:<br/>
                  <strong>{premoneyValuation}</strong>
                </p>
              </div>
            }
            <div className="gap-20"/>
            <div className="icon-content">
              <img
                alt="Euro"
                className="icon"
                src="/img/dollar-big.png"
              />
              <p className="inline-block f-s-20">
                Mi inversión:<br/>
                <strong>{myInvestment}</strong>
              </p>
            </div>
            <div className="gap-20"/>
          </div>
          <div className="col-md-4">
            {props.project.premoneyValuation === 0 ?
              null :
              <div className="icon-content">
                <img
                  alt="Euro"
                  className="icon"
                  src="/img/percent-big.png"
                />
                <p className="inline-block f-s-20">
                  Mi porcentaje de equity:<br/>
                  <strong>
                    {equity} %
                  </strong>
                </p>
              </div>
            }
            <div className="gap-20"/>
            <div className="icon-content">
              <img
                alt="Euro"
                className="icon"
                src="/img/participation-big.png"
              />
              <p className="inline-block f-s-20">
                Mis participaciones:<br/>
                <strong>0</strong>
              </p>
            </div>
            <div className="gap-20"/>
            <div className="icon-content">
              <img
                alt="Euro"
                className="icon"
                src="/img/star-big.png"
              />
              <p className="inline-block f-s-20">
                Precio de la acción:<br/>
                <strong>0</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectMainInfoCardSuccessFundedComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/ProjectMainInfoCardSuccessFunded.component.tsx